<template>
  <div class="footer-btns-box">
    <div class="footer-btns">
      <a
        v-if="moduleData.button1Text"
        :href="moduleData.button1Url"
        class="footer-btn"
        >{{ moduleData.button1Text }}</a
      >
      <a
        v-if="moduleData.button2Text"
        :href="moduleData.button2Url"
        class="footer-btn"
        >{{ moduleData.button2Text }}</a
      >
    </div>
    <div class="mimicode">
      <div class="minicode-img">
        <img :src="moduleData.bottomBigPic" alt />
      </div>
      <!-- <div class="minicode-des">手机扫码立即预定</div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "footerScreen",
  props: {
    moduleData: {
      type: Object,
    },
  },
  data() {
    return {
      hide: "hide",
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
.footer-btns-box {
  margin-top: 100px;
  @include setThemeClass {
    text-align: center;
    // margin-bottom: 100px;
    &:last-child {
      margin-bottom: 100px;
    }
    @include media(
      (
        $home-md: (
          margin-bottom: 60px,
        ),
      )
    );
    .footer-btns {
      margin: 0 auto;
      display: flex;
      width: 420px;
      @include media(
        (
          $home-sm: (
            margin-left: 20px,
            margin-right: 20px,
            width: auto,
          ),
        )
      );
    }
    .footer-btn {
      flex: 1;
      @include bannerButton(getThemeVal(brandColorBlack));
      & + .footer-btn {
        margin-left: 24px;
        @include media(
          (
            $home-sm: (
              margin-left: 16px,
            ),
          )
        );
      }
      &.seemore {
        display: none;
        @include media(
          (
            $home-sm: (
              display: flex,
            ),
          )
        );
      }
    }
    .mimicode {
      overflow: hidden;
      .minicode-img {
        width: 160px;
        height: 160px;
        margin: 0 auto;
        margin-top: 60px;
        margin-bottom: 10px;
        border-radius: 50%;
        background: #fff;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 140px;
        }
      }
      @include media(
        (
          $home-sm: (
            display: none,
          ),
        )
      );
    }
  }
}
</style>
